/**
 * Feedback feature types — derived from the API contract (12.5-api-contract.md).
 * Uses const objects (not enums) for structural compatibility with auto-generated
 * string literal unions in api-types.ts.
 */

export const FeedbackTypeEnum = {
  BUG_REPORT: "BUG_REPORT",
  SUGGESTION: "SUGGESTION",
  COMPLIMENT: "COMPLIMENT",
  COMPLAINT: "COMPLAINT",
} as const;
export type FeedbackTypeEnum =
  (typeof FeedbackTypeEnum)[keyof typeof FeedbackTypeEnum];

export const FeedbackDepartmentEnum = {
  MARKETPLACE: "MARKETPLACE",
  NFT: "NFT",
  TRAVEL: "TRAVEL",
  NETWORK: "NETWORK",
  WALLET: "WALLET",
  GENERAL: "GENERAL",
} as const;
export type FeedbackDepartmentEnum =
  (typeof FeedbackDepartmentEnum)[keyof typeof FeedbackDepartmentEnum];

export const FeedbackStatusEnum = {
  SUBMITTED: "SUBMITTED",
  UNDER_REVIEW: "UNDER_REVIEW",
  ADDRESSED: "ADDRESSED",
} as const;
export type FeedbackStatusEnum =
  (typeof FeedbackStatusEnum)[keyof typeof FeedbackStatusEnum];

export interface FeedbackResponseDto {
  id: string;
  user_id: string;
  rating: number;
  type: FeedbackTypeEnum;
  department: FeedbackDepartmentEnum;
  related_page: string | null;
  message: string;
  status: FeedbackStatusEnum;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
}

export interface PaginationDto {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  nextPage: number | null;
  prevPage: number | null;
  firstPage: number;
  lastPage: number;
}

export interface WrappedResponse<T> {
  statusCode: number;
  data: T;
  error: boolean;
  errorData: Record<string, unknown> | null;
}

export interface CreateFeedbackRequest {
  rating: number;
  type: FeedbackTypeEnum;
  department: FeedbackDepartmentEnum;
  related_page?: string;
  message: string;
}

export interface FeedbackListResponse {
  result: FeedbackResponseDto[];
  pagination: PaginationDto;
}

/** Persian labels for feedback types */
export const FEEDBACK_TYPE_LABELS: Record<FeedbackTypeEnum, string> = {
  [FeedbackTypeEnum.BUG_REPORT]: "گزارش باگ",
  [FeedbackTypeEnum.SUGGESTION]: "پیشنهاد",
  [FeedbackTypeEnum.COMPLIMENT]: "تشکر",
  [FeedbackTypeEnum.COMPLAINT]: "شکایت",
};

/** Persian labels for feedback departments */
export const FEEDBACK_DEPARTMENT_LABELS: Record<
  FeedbackDepartmentEnum,
  string
> = {
  [FeedbackDepartmentEnum.MARKETPLACE]: "بازار",
  [FeedbackDepartmentEnum.NFT]: "NFT",
  [FeedbackDepartmentEnum.TRAVEL]: "سفر و گردشگری",
  [FeedbackDepartmentEnum.NETWORK]: "شبکه",
  [FeedbackDepartmentEnum.WALLET]: "کیف پول",
  [FeedbackDepartmentEnum.GENERAL]: "عمومی",
};

/** Persian labels for feedback statuses */
export const FEEDBACK_STATUS_LABELS: Record<FeedbackStatusEnum, string> = {
  [FeedbackStatusEnum.SUBMITTED]: "ثبت شده",
  [FeedbackStatusEnum.UNDER_REVIEW]: "در حال بررسی",
  [FeedbackStatusEnum.ADDRESSED]: "رسیدگی شده",
};

/** Related page options for the form dropdown */
export const RELATED_PAGE_OPTIONS = [
  { value: "home", label: "صفحه اصلی" },
  { value: "products", label: "محصولات" },
  { value: "nft_marketplace", label: "بازار NFT" },
  { value: "travel", label: "سفر و گردشگری" },
  { value: "profile", label: "پروفایل" },
  { value: "checkout", label: "فرآیند خرید" },
  { value: "vendor", label: "فروشگاه‌ها" },
  { value: "network", label: "شبکه و پاداش" },
] as const;
